import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

/**
 * Денний баланс клієнта за день з усіх подій їжі й тренувань - і виконаних, і ще не підтверджених (у застосунку
 * клієнта - лише виконані, тож числа можуть відрізнятись).
 * `null` - клієнт не надав експерту доступу до цієї частини календаря ("Їжа" / "Тренування").
 */
export interface ClientDailyBalance {
  date: string; // yyyy-MM-dd
  caloriesConsumed: number | null;
  proteinG: number | null;
  fatG: number | null;
  carbsG: number | null;
  caloriesBurned: number | null;
}

/** Дні з подіями в проміжку [from, to] (yyyy-MM-dd, включно). Без доступу до їжі й тренувань бекенд відповідає 403. */
export const getClientDailyBalance = async (clientId: string | number, from: string, to: string): Promise<ClientDailyBalance[]> => {
  const params = new URLSearchParams({ from, to });
  const response = await api.get<ApiResponse<ClientDailyBalance[]>>(`/tracking/clients/${clientId}/daily-balance?${params.toString()}`);
  const data = unwrapApiResponse<ClientDailyBalance[]>(response);
  return Array.isArray(data) ? data : [];
};
